module.exports = __webpack_public_path__ + "static/img/stamp_process.7308d817.svg";